module.exports = __webpack_public_path__ + "static/img/slide_7_en.2ba572d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_7_en.svg
// module id = UCd6
// module chunks = 0